export default "__VITE_ASSET__0I0gGYT54E8zRKvPRpaQZQ__"